import { PilaV } from '@/components/atomos';
import { anchoMaximo } from '@/styles/constants';
import { FC, PropsWithChildren } from 'react';

export const ContenidoAviso: FC<PropsWithChildren> = ({ children }) => {
  return (
    <PilaV
      maxW={anchoMaximo}
      alignItems={'start'}
      fontSize={'lg'}
      py={8}
      spacing={4}
      px={4}
      animation={'fadeIn 500ms forwards'}
    >
      {children}
    </PilaV>
  );
};

export const ContenedorAviso: FC<PropsWithChildren> = ({ children }) => {
  return (
    <PilaV w={'full'} flexGrow={1}>
      {children}
    </PilaV>
  );
};
